// extracted by mini-css-extract-plugin
export default {"mainDiv":"Github_mainDiv__eoAqw","h1Tag":"Github_h1Tag__wfII8"};